import { ElementRef, Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { ScrollHelper } from '../helpers/ScrollHelper';

@Injectable({
  providedIn: 'root',
})
export class ScrollService implements OnDestroy {
  rootElementRef: ElementRef;
  scrollToTop = false;
  navigationEndSub: Subscription;

  constructor(private router: Router) {}

  handleScrollAfterLoad() {
    ScrollHelper.scrollToElementAfterTick(this.rootElementRef.nativeElement);
  }

  routeSearch =
    (routeList: string[]) =>
    (routeUrl: string): boolean => {
      return routeList.some((route) => {
        return routeUrl.startsWith(route);
      });
    }

  init(el: ElementRef, routeList: string[]) {
    this.rootElementRef = el;
    const checkForRoute = this.routeSearch(routeList);

    const navigationEnd$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    );

    this.navigationEndSub = navigationEnd$.subscribe((end: NavigationEnd) => {
      // If current route is in routeList, set scrollToTop ready for handleScrollAfterLoad
      this.scrollToTop = checkForRoute(end.url);
    });
  }

  ngOnDestroy() {
    this.navigationEndSub.unsubscribe();
  }
}
